import { observer } from 'mobx-react-lite';

import Stack from "@mui/joy/Stack";
import Grid from "@mui/joy/Grid";

// import Typography from "@mui/joy/Typography";
// import Divider from "@mui/joy/Divider";
// import IdentityAvatar from './IdentityAvatar';
// import useCollabs from '../hooks/useCollabs';
// import useClock from '../hooks/useClock';

import PhoneTopperCollabCallLog from './PhoneTopperCollabCallLog';
import PhoneTopperCallStatus from './PhoneTopperCallStatus';


const PhoneTopperCollabInfo = observer(({ associated_type, associated_uuid }: { associated_type: string, associated_uuid: string }) => {
    //    const { currentClock } = useClock();
    //    const { getCollab } = useCollabs();


    return (
        <Grid container sx={{ width: "100%" }}>
            <Grid sm={12} md={6}>
            <Stack padding={1} spacing={1} borderColor={"divider"}>

                {/*
                <Divider>Calling on behalf of</Divider>
                <IdentityAvatar
                    interactive={false}
                    size="inline"
                    identityKey={currentCollab.identity} />
                <Divider >Collab Goal</Divider>
                <Typography level="body-sm">
                    {currentCollab.description}
                </Typography> */}

                <PhoneTopperCallStatus />
            </Stack>
            </Grid>
            <Grid sm={12} md={6}>
            <Stack padding={1} spacing={1} borderLeft={1} borderColor={"divider"}>
                <PhoneTopperCollabCallLog
                    associated_type={associated_type}
                    associated_uuid={associated_uuid} />


            </Stack>
            </Grid>
        </Grid>
    );
});

export default PhoneTopperCollabInfo;
